<template>
	<div class="returnvisit">
		<div class="header">
			<el-row>
				<el-col :span="6">
					<label class="headerlabel">单位名称</label>
					<el-input v-model="param.deptName" placeholder="" class="autowidth" clearable></el-input>
				</el-col>
				<el-col :span="6">
					<label class="headerlabel">回访方式</label>
					<el-input v-model="param.followUpMethods" placeholder="" class="autowidth" clearable></el-input>
				</el-col>
				<el-col :span="6">
					<label class="headerlabel">回访时间</label>
					<el-date-picker class="autowidth" clearable v-model="FollowUpDate" @change="setDate()" type="daterange" format="yyyy-MM-dd" value-format="yyyy-MM-dd" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"></el-date-picker>
				</el-col>
				<el-col :span="6">
					<el-button type="primary" style="margin-left: 24px" @click="init">筛选</el-button>
					<el-button @click="reset">重置条件</el-button>
				</el-col>
			</el-row>
		</div>

		<main class="MainContent">
			<div>
				<el-button type="primary" @click="btnadd()" class="addbtn">新增</el-button>
			</div>

			<el-table :data="MemberData" v-loading="loading" element-loading-text="拼命加载中" element-loading-spinner="el-icon-loading" style="width: 100%; margin-bottom: 20px">
				<el-table-column label="序号" width="60px" align="left">
					<template slot-scope="scope">
						{{ (param.pageIndex - 1) * param.pageSize + scope.$index + 1 }}
					</template>
				</el-table-column>
				<el-table-column prop="deptName" label="单位名称"></el-table-column>
				<el-table-column prop="followUpContent" label="回访内容"></el-table-column>
				<el-table-column prop="followUpMethods" label="回访方式"></el-table-column>
				<el-table-column prop="followUpDate" label="回访时间"></el-table-column>
				<el-table-column label="操作">
					<template slot-scope="scope">
						<el-button type="text" @click="updaterow(scope.row)">跟进</el-button>
						<el-button type="text" @click="deleterow(scope.row.requestKey)" style="margin-right: 20px">删除</el-button>
					</template>
				</el-table-column>
			</el-table>
			<el-pagination :hide-on-single-page="true" @current-change="handleinitialization" :current-page.sync="param.pageNum" :page-size="param.pageSize" layout="total, prev, pager, next" :total="param.PageTotal"></el-pagination>
		</main>
		<el-dialog title="回访内容" :visible.sync="centerDialogVisible" width="400px" center v-loading="iuformloading">
			<el-form label-width="80px" style="width: 320px" ref="form" :rules="rules" :model="form">
				<el-form-item label="单位名称" prop="deptName">
					<el-input v-model="form.deptName"></el-input>
				</el-form-item>

				<el-form-item label="回访类型" prop="followUpMethods">
					<el-input v-model="form.followUpMethods"></el-input>
				</el-form-item>

				<el-form-item label="回访内容 " prop="followUpContent">
					<el-input type="textarea" v-model="form.followUpContent"></el-input>
				</el-form-item>

				<el-form-item label="回访时间 " prop="followUpDates">
					<el-date-picker v-model="form.followUpDate" style="width: 100%" type="date" placeholder="选择日期" format="yyyy 年 MM 月 dd 日" value-format="yyyy-MM-dd"></el-date-picker>
				</el-form-item>
			</el-form>
			<span slot="footer" class="dialog-footer">
				<el-button @click="centerDialogVisible = false">取 消</el-button>
				<el-button type="primary" @click="submit()">确 定</el-button>
			</span>
		</el-dialog>
	</div>
</template>
<script>
	export default {
		data() {
			return {
				Finalpaymenttime: [],
				centerDialogVisible: false,
				loading: false,
				iuformloading: false,
				FollowUpDate: [],
				param: {
					deptName: '',
					followUpMethods: '',
					startDate: '',
					endDate: '',
					pageIndex: 1,
					pageSize: 10,
					PageTotal: 0,
				},
				MemberData: [],
				searchValue: '',
				MemeberPackageData: [],
				form: {
					requestKey: '',
					deptName: '',
					followUpMethods: '',
					followUpContent: '',
					followUpDate: '',
				},
				rules: {
					DeptName: [{ required: true, message: '请输入单位名称', trigger: 'blur' }],
					FollowUpMethods: [{ required: true, message: '请输入回访类型', trigger: 'blur' }],
					FollowUpDates: [{ type: 'date', required: true, message: '请选择日期', trigger: 'change' }],
					FollowUpContent: [{ required: true, message: '请填写回访内容', trigger: 'blur' }],
				},
			};
		},
		watch: {
			Finalpaymenttime(newval, oldval) {
				if (newval == null) {
					this.param.startExpiration = '';
					this.param.endExpiration = '';
				} else {
					this.param.startExpiration = newval[0];
					this.param.endExpiration = newval[1];
				}
			},
		},
		mounted() {
			this.init();
		},
		methods: {
			// 查询会员类型(会员套餐接口)
			setDate() {
				this.param.startDate = this.FollowUpDate[0];
				this.param.endDate = this.FollowUpDate[1];
			},
			btnadd() {
				this.centerDialogVisible = true;
			},
			updaterow(row) {
				this.centerDialogVisible = true;
				this.form = row;
			},

			submit() {
				this.iuformloading = true;
				if (this.form.requestKey == '') {
					this.$Http_Post('/ServiceFollowUp/PostAddFollowUp', this.form).then((res) => {
						this.loading = false;
						if (res.Code == 0 || res.Code == 200) {
							this.$message({
								type: 'success',
								message: '添加成功!',
							});

							this.centerDialogVisible = false;
							this.init();
						} else {
							this.$message.error(res.Message);
						}
						this.iuformloading = false;
					});
				} else {
					this.form.requestKey = this.form.requestKey + '';
					this.$Http_Post('/ServiceFollowUp/PostUpdateFollowUp', this.form).then((res) => {
						this.loading = false;
						if (res.Code == 0 || res.Code == 200) {
							this.$message({
								type: 'success',
								message: '成功跟进!',
							});
							this.centerDialogVisible = false;
							this.init();
						} else {
							this.$message.error(res.Message);
						}
						this.iuformloading = false;
					});
				}
			},
			init() {
				this.loading = true;
				this.$Http_Post('/ServiceFollowUp/PostFollowUpList', this.param).then((res) => {
					this.loading = false;
					if (res.Code == 0 || res.Code == 200) {
						this.param.PageTotal = res.Counts;
						this.MemberData = res.Data;
					} else {
						this.$message.error(res.Message);
					}
				});
			},
			reset() {
				this.param = {
					DeptName: '',
					FollowUpMethods: '',
					StartDate: '',
					EndDate: '',
					pageIndex: 1,
					pageSize: 10,
					PageTotal: 0,
				};
				this.FollowUpDate = [];
				this.init();
			},
			handleinitialization(val) {
				this.param.pageNum = val;
				this.init();
			},
			deleterow(row) {
				this.$confirm('此操作将永久删除该信息, 是否继续?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning',
				})
					.then(() => {
						this.$Http_Post('/ServiceFollowUp/PostDeleteFollowUp', {
							RequestKey: row,
						}).then((res) => {
							if (res.Code == 0 || res.Code == 200) {
								this.$message({
									type: 'success',
									message: '删除成功!',
								});
								this.init();
							} else {
								this.$message({
									type: 'success',
									message: res.Message,
								});
							}
						});
					})
					.catch(() => {
						this.$message({
							type: 'info',
							message: '已取消删除',
						});
					});
			},
		},
	};
</script>
<style>
	.returnvisit .header {
		background: #fff;
		padding: 20px;
	}
	.returnvisit .header .headerlabel {
		width: 90px;
		display: inline-block;
	}
	.returnvisit .autowidth {
		width: 240px;
	}
	.returnvisit .MainContent {
		background: #fff;
		padding: 20px 16px;
		margin: 16px 0;
	}
	.returnvisit .addbtn {
		margin-bottom: 10px;
	}
</style>
